import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (backend/modules/j219/models/j219.go)
// ============================================================

export interface FJ741 {
  fj741_01: string; // 分析單號 (FK→FJ740)
  fj741_02: number; // 項次
  fj741_11: string; // 洗標代號
  fj741_12: string; // 洗標說明
}

export interface FJ740 {
  fj740_01: string;         // 分析單號 (PK)
  fj740_11: string;         // 開發單號
  fj740_12: string | null;  // 入單日期 (ISO)
  fj740_13: string;         // 產品用途
  fj740_14: string;         // 廠商收件單號
  fj740_15: number;         // 廠商收件項次
  fj740_161: string;        // 產品代號1
  fj740_162: string;        // 產品代號2
  fj740_17: string;         // 規格 (memo)
  fj740_171: string;        // 規格單位
  fj740_172: string;        // 規格備註
  fj740_18: number;         // 布樣數量
  fj740_181: number;        // 繳交研發處布樣數量
  fj740_19: string;         // 單位1
  fj740_191: string;        // 單位2
  // Page2 紗線第1層
  fj740_201: number;  // 面/底
  fj740_202: string;  // 成份
  fj740_203: string;  // D/f's
  fj740_204: number;  // 種類 (SD/FD/...)
  fj740_205: number;  // 原/加
  fj740_206: number;  // 成本
  fj740_207: string;  // 單位
  fj740_208: string;  // 供應商
  // Page2 紗線第2層
  fj740_211: number;
  fj740_212: string;
  fj740_213: string;
  fj740_214: number;
  fj740_215: number;
  fj740_216: number;
  fj740_217: string;
  fj740_218: string;
  // Page2 紗線第3層
  fj740_221: number;
  fj740_222: string;
  fj740_223: string;
  fj740_224: number;
  fj740_225: number;
  fj740_226: number;
  fj740_227: string;
  fj740_228: string;
  // Page2 織布工程
  fj740_23: string;   // 組織
  fj740_231: number;  // 毛圈長
  fj740_232: number;  // 針數
  fj740_233: number;  // 口數
  fj740_234: number;  // 圓徑
  fj740_241: number;  // 幅寬內
  fj740_242: number;  // 幅寬外
  fj740_251: number;  // 成份1%
  fj740_252: number;  // 成份2%
  fj740_253: number;  // 成份3%
  fj740_261: number;  // 重量1
  fj740_262: number;  // 重量2
  fj740_27: string;   // 織布工繳代號
  fj740_281: number;  // 織布成本
  fj740_282: string;  // 織布單位
  fj740_29: string;   // 織布供應商
  fj740_291: string;  // 工廠布號
  // Page3 染整第1層
  fj740_301: string;  // 工繳代號1
  fj740_302: number;  // 大貨價1
  fj740_303: number;  // 試樣價1
  fj740_304: string;  // 單位1
  fj740_305: number;  // 縮率1
  fj740_306: string;  // 備註1
  fj740_307: string;  // 加工廠1
  // Page3 染整第2層
  fj740_311: string;
  fj740_312: number;
  fj740_313: number;
  fj740_314: string;
  fj740_315: number;
  fj740_316: string;
  fj740_317: string;
  // Page3 染整第3層
  fj740_321: string;
  fj740_322: number;
  fj740_323: number;
  fj740_324: string;
  fj740_325: number;
  fj740_326: string;
  fj740_327: string;
  // Page3 成品
  fj740_41: string;   // 織布廠
  fj740_42: number;   // 織工
  fj740_43: string;   // 織布單位
  fj740_44: string;   // 機台
  fj740_45: number;   // 織縮
  fj740_46: number;
  fj740_47: number;
  fj740_51: string;   // 成品組織
  fj740_521: number;  // 成品幅寬內
  fj740_522: number;  // 成品幅寬外
  fj740_531: number;  // 成品成份1%
  fj740_532: number;  // 成品成份2%
  fj740_533: number;  // 成品成份3%
  fj740_541: number;  // 成品重量1
  fj740_542: number;  // 成品重量2
  fj740_55: string;   // 成品工繳代號
  fj740_561: number;  // 成品成本
  fj740_562: string;  // 成品單位
  fj740_57: string;   // 成品供應商
  fj740_571: string;  // 工廠布號
  fj740_581: number;  // 毛圈長(成品)
  fj740_582: number;  // 針數(成品)
  fj740_583: number;  // 口數(成品)
  fj740_584: number;  // 圓徑(成品)
  // Page3 物化性報告
  fj740_61: string;   // 物化性報告單1
  fj740_611: string;  // 物化性報告單2
  fj740_612: string;  // 物化性報告單3
  fj740_62: string;   // 建單人員
  fj740_63: string;   // 部門
  fj740_64: string;   // 備註1
  fj740_65: string;   // 備註2
  // 管理欄位
  fj740_76: string;         // 業務分析單號
  fj740_77: string | null;  // 公告開始日
  fj740_78: string | null;  // 公告終止日
  fj740_79: number;         // 洗標項數
  fj740_80: string;         // 核准狀態
  fj740_91: string;         // 修改人
  fj740_92: string | null;  // 修改時間
  fj740_93: string;         // 建立人

  // Associations
  details?: FJ741[];
}

export interface CreateJ219Request {
  master: Partial<FJ740>;
  details: Partial<FJ741>[];
}

export interface UpdateJ219Request {
  master: Partial<FJ740>;
  details: Partial<FJ741>[];
}

export interface J219ListResponse {
  data: FJ740[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API Client
// ============================================================

const BASE = '/api/j219';

export const j219Api = {
  list(params?: { page?: number; size?: number; keyword?: string }): Promise<J219ListResponse> {
    const query = new URLSearchParams();
    if (params?.page) query.set('page', String(params.page));
    if (params?.size) query.set('size', String(params.size));
    if (params?.keyword) query.set('keyword', params.keyword);
    const qs = query.toString();
    return apiClient.get(`${BASE}${qs ? '?' + qs : ''}`).then(r => r.data);
  },

  getById(id: string): Promise<FJ740> {
    return apiClient.get(`${BASE}/${encodeURIComponent(id)}`).then(r => r.data);
  },

  create(data: CreateJ219Request): Promise<FJ740> {
    return apiClient.post(BASE, data).then(r => r.data);
  },

  update(id: string, data: UpdateJ219Request): Promise<FJ740> {
    return apiClient.put(`${BASE}/${encodeURIComponent(id)}`, data).then(r => r.data);
  },

  delete(id: string): Promise<{ message: string }> {
    return apiClient.delete(`${BASE}/${encodeURIComponent(id)}`).then(r => r.data);
  },
};

export default j219Api;
